import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useTranslation } from 'react-i18next';

type AlertsStatusButtonProps = {
  onPress: () => void;
  isEnableAction: boolean;
  disabled?: boolean;
};

export const AlertsStatusButton = ({ 
  onPress, 
  isEnableAction,
  disabled = false 
}: AlertsStatusButtonProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.buttonContainer}>
      <TouchableOpacity
        style={[styles.button, disabled && styles.buttonDisabled]}
        onPress={onPress}
        disabled={disabled}
      >
        <MaterialCommunityIcons
          name={isEnableAction ? 'check-circle-outline' : 'cancel'}
          color={disabled ? Colors.role.textDisabled : Colors.role.textPrimary}
          size={16}
          style={styles.icon}
        />
        <Text style={[styles.label, disabled && styles.labelDisabled]}>
          {isEnableAction 
            ? t('alertsManagement.actions.enable') 
            : t('alertsManagement.actions.disable')
          }
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16,
    height: 32,
    backgroundColor: Colors.role.surface,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.role.surfaceActive,
  },
  buttonDisabled: {
    opacity: 0.5,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: -0.25,
    color: Colors.role.textStrong,
  },
  labelDisabled: {
    color: Colors.role.textDisabled,
  },
});
